// Shared "scroll to the first invalid field" handler for AddFormV1/EditFormV1.
// Wire it from the antd Form's onFinishFailed: when Create/Save is clicked with
// validation errors, the screen scrolls to the first errored field, focuses it
// (cursor placed in the input) and pulses a red halo so the user sees exactly
// which field failed. Generic — works for every module's add & edit form.
//
// Robustness notes:
//  - antd applies the .ant-form-item-has-error classes AFTER onFinishFailed
//    fires, so location runs on a short delay.
//  - The DOM query + scrollIntoView is the PRIMARY mechanism and always runs.
//    form.scrollToField is only a best-effort extra: antd locates fields by
//    DOM id, which custom field controls don't always forward — relying on it
//    alone silently scrolls nothing.
//  - Callers should expand any collapsed sections BEFORE calling this (a field
//    inside a display:none section can be neither scrolled to nor focused) —
//    both form engines do so in their onFinishFailed wrapper.
export function scrollToFirstFormError({ errorFields } = {}, form) {
  if (!errorFields?.length) return;
  const firstName = errorFields[0]?.name;

  setTimeout(() => {
    if (form?.scrollToField && firstName !== undefined) {
      try {
        form.scrollToField(firstName, { behavior: 'smooth', block: 'center' });
      } catch { /* best-effort only — the DOM scroll below always runs */ }
    }

    const errorFormItem = document.querySelector('.ant-form-item-has-error');
    if (!errorFormItem) return;
    const input = errorFormItem.querySelector('input, textarea, select, .ProseMirror');
    const target = input ?? errorFormItem;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });

    setTimeout(() => {
      input?.focus?.({ preventScroll: true });
      target.style.boxShadow = '0 0 0 3px rgba(255, 77, 79, 0.3)';
      setTimeout(() => { target.style.boxShadow = ''; }, 1200);
    }, 350);
  }, 60);
}

export default scrollToFirstFormError;
